import type { IEquipmentType } from '@/types/hvl/EquipmentType'
import type { IEquipmentTypeFilters } from '@/types/hvl/filters'
import type { IBulkIDsDeleteForm, IEquipmentTypeUpsertForm } from '@/types/hvl/forms'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getEquipmentTypes(filters: IEquipmentTypeFilters): Promise<IPage<IEquipmentType>> {
  const res = await axios.get(import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT, {
    params: filters,
  })
  return res.data
}

export async function createEquipmentType(form: IEquipmentTypeUpsertForm): Promise<any> {
  const res = await axios.post(import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT, form)
  return res.data
}

export async function updateEquipmentType(id: number, form: IEquipmentTypeUpsertForm): Promise<any> {
  const res = await axios.put(`${import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT}/${id}`, form)
  return res.data
}

export async function deleteEquipmentType(id: number): Promise<any> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT}/${id}`)
  return res.data
}

export async function deleteInspectionPoints(equipmentTypeId: number, form: IBulkIDsDeleteForm): Promise<any> {
  const res = await axios.delete(
    `${import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT}/${equipmentTypeId}/inspection-points`,
    {
      data: { ids: form.ids },
    }
  )
  return res.data
}

export async function deleteFailureTypes(equipmentTypeId: number, form: IBulkIDsDeleteForm): Promise<any> {
  const res = await axios.delete(
    `${import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT}/${equipmentTypeId}/failure-types`,
    {
      data: { ids: form.ids },
    }
  )
  return res.data
}

export async function deleteRepairActions(equipmentTypeId: number, form: IBulkIDsDeleteForm): Promise<any> {
  const res = await axios.delete(
    `${import.meta.env.VITE_APP_HVL_EQUIPMENT_TYPE_ENDPOINT}/${equipmentTypeId}/repair-actions`,
    {
      data: { ids: form.ids },
    }
  )
  return res.data
}
